import { render } from "./CreateNewThemeChart.vue?vue&type=template&id=2cb7f14c"
import script from "./CreateNewThemeChart.vue?vue&type=script&lang=js"
export * from "./CreateNewThemeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__